import api from '../helpers/axios';

const BASE_URL = '/print-requests';
const fetch = id => api.get(BASE_URL + '/' + id).then(res => res);

export const printService = {
  fetch
};
